<template>
  <section id="work">


    <!-- 显示所有图片 -->
    <div class="image-container">
      <div v-for="(image, index) in images" :key="index" class="image-item" @mouseover="handleMouseOver(index)"
        @mouseleave="handleMouseLeave(index)">
        <img :src="image.src" alt="Work Image" :style="getImageStyle(index)" />
        <!-- 点击透明容器触发 Lightbox -->
        <div class="overlay" @click="openLightbox(index)"></div>
      </div>
    </div>

    <!-- Lightbox Overlay -->
    <div v-if="isLightboxOpen" class="lightbox-overlay" @click="closeLightbox">
      <div class="lightbox-content">
        <div class="lightbox-image" @click="closeLightbox">
          <img :src="currentImage.src" alt="Lightbox Image" />
        </div>
        <div class="lightbox-description">
          <p>{{ currentDescription }}</p> <!-- 显示描述 -->
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import descriptions from '@/assets/images/description.json'; // 导入 JSON 描述数据

export default {
  name: 'WorkSection',
  data() {
    return {
      images: [], // 存储所有图片及描述
      isLightboxOpen: false, // 控制 Lightbox 的显示与隐藏
      currentImageIndex: 0, // 当前显示的图片索引
      imageFilters: [], // 存储每张图片的滤镜效果
      imageScales: [], // 存储每张图片的缩放级别
    };
  },
  created() {
    this.loadImages(); // 加载所有图片
  },
  methods: {
    // 从 JSON 加载所有图片和描述
    loadImages() {
      this.images = Object.keys(descriptions).map(imageName => {
        return {
          src: require(`@/assets/images/${imageName}`), // 动态加载该图片
          description: descriptions[imageName].description, // 获取该图片的描述
        };
      });
      this.imageScales = new Array(this.images.length).fill(1); // 初始化所有图片的缩放为 1
      this.imageFilters = new Array(this.images.length).fill('grayscale(100%)'); // 默认显示灰度效果
    },
    // 打开 Lightbox
    openLightbox(index) {
      this.currentImageIndex = index;
      this.isLightboxOpen = true;
    },
    // 关闭 Lightbox
    closeLightbox() {
      this.isLightboxOpen = false;
    },
    // 处理 Lightbox 内容区域点击，防止点击事件冒泡
    handleContentClick(event) {
      event.stopPropagation(); // 阻止点击事件冒泡，防止关闭 Lightbox
    },
    // 鼠标悬停时恢复原图颜色并缩放
    handleMouseOver(index) {
      this.imageFilters[index] = ''; // 恢复原图颜色
      this.imageScales[index] = 1.1; // 鼠标悬停时缩放图片
    },
    // 鼠标移出时应用灰度效果并恢复缩放
    handleMouseLeave(index) {
      this.imageFilters[index] = 'grayscale(80%)'; // 应用灰度效果
      this.imageScales[index] = 1; // 恢复原始大小
    },
    // 获取每张图片的动态样式，包括滤镜效果和缩放
    getImageStyle(index) {
      return {
        filter: this.imageFilters[index], // 动态滤镜（使用灰度）
        transform: `scale(${this.imageScales[index]})`, // 动态缩放
        transition: 'filter 0.3s ease, transform 0.3s ease', // 平滑过渡
      };
    },
  },
  computed: {
    // 获取当前显示的图片
    currentImage() {
      return this.images[this.currentImageIndex];
    },
    // 获取当前图片的描述
    currentDescription() {
      return this.currentImage ? this.currentImage.description : 'No description available';
    },
  },
};
</script>


<style scoped>
#work {
  margin-top: 8vw;
  padding-top: 5vh;
  background-color: #000;
  color: #fff;
  text-align: center;
}

h2 {
  margin-top: 2vw;
    padding-top: 2vh;
  color: #0026ff;
  font-size: 3vh;
}

/* 图片容器 */
.image-container {
  display: flex;
  gap: 0.5vw;
  row-gap: 2vw;
  position: relative;
  flex-direction: row;
  flex-wrap: wrap;
  align-content: center;
  justify-content: space-evenly;
  align-items: center;
}

/* 每张图片的样式 */
.image-item {
  width: 50vw;
  height: 12vw;
  position: relative;
  /* 相对定位容器，用于放置透明叠加容器 */
  cursor: pointer;
}

.image-item img {
  width: 50vw;
  height: 12vw;
  object-fit: cover;
  transition: filter 0.3s ease;
  /* 图片滤镜过渡 */
}

/* 透明叠加容器 */
.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0);
  /* 半透明背景 */
  z-index: 999;
  /* 使其覆盖在图片上 */
  cursor: pointer;
  /* 鼠标悬停时显示手型 */
}

/* Lightbox Overlay */
.lightbox-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.825);
  /* Lightbox 背景透明 */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  padding: 0;
  margin: 0;
}

/* Lightbox 内容 */
.lightbox-content {
  display: flex;
  background-color: transparent;
  max-width: 100%;
  max-height: 100%;
  padding: 0;
  gap: 3vw;
  width: 90%;
  height: 100%;
  flex-direction: row;
  align-items: center;
}

/* 图片部分 */
.lightbox-image img {
  /* width: 60%;; */
  /* height: 100%; */
  object-fit: contain;
  max-width: 60vw;
  /* 限制图片最大宽度 */
}

/* 描述部分 */
.lightbox-description {
  color: #fff;
  font-size: 2vh;
  /* 文字大小为0.5vw */
  line-height: 1.6;
  width: 35vw;
  /* 限制文字区域宽度 */
  text-align: left;
  max-height: 80%;
  overflow-y: auto;
}
</style>
